module.exports = __webpack_public_path__ + "static/media/lower_active.283cef81.svg";